import { useTranslation } from 'react-i18next';
import { LuUsers } from 'react-icons/lu';

export const BothApplicantsComposerCallout = () => {
    const { t } = useTranslation();

    return (
        <div className="shrink-0 border-t border-outline-light bg-surface-light px-4 py-3">
            <div className="flex items-center gap-2 text-sm text-midnight">
                <LuUsers className="shrink-0" />
                <span>{t('WHATSAPP_CHAT.COMPOSER.BOTH_APPLICANTS_HINT')}</span>
            </div>
        </div>
    );
};
